import { render } from "./nicView.vue?vue&type=template&id=bbf5bbc0"
import script from "./nicView.vue?vue&type=script&lang=js"
export * from "./nicView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\webencusco\\projects\\admin-carta\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__